import React from "react";

export const ChartSkeleton: React.FC<{ compact?: boolean }> = ({ compact = false }) => (
  <div className={`skeleton skeleton-chart ${compact ? "compact" : ""}`} />
);

export const CardSkeleton: React.FC = () => (
  <div className="skeleton-card">
    <div className="skeleton skeleton-line short" style={{ marginBottom: "1rem" }} />
    <div className="skeleton skeleton-chart compact" style={{ marginBottom: "1rem" }} />
    <div className="skeleton skeleton-line medium" />
    <div className="skeleton skeleton-line full thin" />
  </div>
);

export const TableRowSkeleton: React.FC<{ rows?: number }> = ({ rows = 5 }) => (
  <>
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="skeleton-table-row">
        <div className="skeleton skeleton-line" style={{ flex: "0 0 40px" }} />
        <div className="skeleton skeleton-line" style={{ flex: "0 0 80px" }} />
        <div className="skeleton skeleton-line" style={{ flex: 1 }} />
        <div className="skeleton skeleton-line" style={{ flex: "0 0 60px" }} />
      </div>
    ))}
  </>
);
